import { StatusCodes } from "http-status-codes";

/**
 * Database query pre-processor
 * @param request
 * @returns Status code
 */
export function getStatusCode(request: any): StatusCodes {
    if (request.code === "ERR_NETWORK") { //Network Error
        return 504;
    };
    
    if (request.status >= 200 && request.status < 300) { //Success range
        return request.status;
    };
    
    return request.response.status; //Error & Redirection range
};